import { Injectable } from '@angular/core';
import { BrowserService } from 'webcommon/legacy-common';

// Creating canvas for measuring text width
const canvas: HTMLCanvasElement = document.createElement('canvas');
const context: CanvasRenderingContext2D = canvas.getContext('2d') as CanvasRenderingContext2D;

// Uses Canvas measureText() to compute and return the width of the given text of given font in pixels
function getStringWidth(text: string, font: string): number {
  context.font = font;
  const metrics: TextMetrics = context.measureText(text);
  return metrics.width;
}

@Injectable({
  providedIn: 'root',
})
export class CanvasService {
  constructor(
    private readonly browserService: BrowserService,
  ) {

  }

  getComputedStyleForSelector(selector: string) {
    const documentObj = this.browserService.getDocument();
    const windowObj = this.browserService.getWindow();
    const element = documentObj.querySelector(selector);
    const computedStyles = !element ? undefined : windowObj.getComputedStyle(element);
    return computedStyles;
  }

  getStringWidth(text: string, font: string) {
    return getStringWidth(text, font);
  }
}
